import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class SdoService extends BaseService{

  constructor(private http: HttpClient, tokenService: TokenService) { 
    super(tokenService);
  }
 
  //GET SERVICE
  getAppForPhysicalVerMIDone(autoId:any){
    return this.http.get(`${environment.apiUrl}Department/GetApplicationsForPhysicalVerMIDone?AutoId=${autoId}`, { headers: this.buildHeaders() });
  }

  //GET data for Physical Verification 
  getDataOfPhysicalVerMIDone(autoId:any){
    return this.http.get(`${environment.apiUrl}Department/GetDataOfPhysicalVerMIDone?AutoId=${autoId}`, { headers: this.buildHeaders() });
 
  }
}
